const completeConfig = `{
  id
  teamId
  zoomAccountEmail
}`

export const GET_ZOOM_CONFIG = id => `{
  zoomConfig(zoomConfigId: "${id}") ${completeConfig}}`

export const GET_ZOOM_CONFIGS = `{
  zoomConfig ${completeConfig}
}`



// WEBPACK FOOTER //
// ./src/graphql_queries/zoom_config_queries.js